// tslint:disable
export const MOTTOS = [
  {
    date: '2021-07-01',
    quoteText: 'Oberflächlichkeit fördert die Spontanität. Tiefgründigkeit fördert die gesamte Entwicklung.',
    author: 'Sylvia Amstadt',
  },
  {
    date: '2021-07-02',
    quoteText: 'Leistung ist das Ergebnis von Motivation.',
    author: 'Martin Fietzek',
  },
  {
    date: '2021-07-03',
    quoteText: 'Alleine auf einer Parkbank zu sitzen ist manchmal auch Inspiration.',
    author: 'Klaus',
  },
  {
    date: '2021-07-04',
    quoteText: 'Erfolg hat immer mit Teamwork zu tun.',
    author: 'Hannes Feiersinger',
  },
  {
    date: '2021-07-05',
    quoteText: 'Ohne meine Stimmungsschwankungen gäbe es ja gar keine Stimmung.',
    author: 'Sylvia Amstadt',
  },
  {
    date: '2021-07-06',
    quoteText: 'Komplizierte Dinge brauchen Konzentration, schwierige Dinge brauchen Motivation.',
    author: 'Kühn-Görg Monika',
  },
  {
    date: '2021-07-07',
    quoteText: 'Der Geist braucht Inspiration, um zu inspirieren.',
    author: 'Klaus Seibold',
  },
  {
    date: '2021-07-08',
    quoteText: '10 Prozent Strategie, 90 Prozent Kommunikation ergeben 100 Prozent Team - Erfolg!',
    author: 'Andre Dieckschulte',
  },
  {
    date: '2021-07-09',
    quoteText: 'Schön, dass du heute hier bist!',
    author: 'Dein Alberta-Team',
  },
  {
    date: '2021-07-10',
    quoteText: 'Auch eine Reise von tausend Meilen beginnt mit einem Schritt.',
    author: 'Laotse',
  },
  {
    date: '2021-07-11',
    quoteText: 'Man kann viel, wenn man sich nur recht viel zutraut.',
    author: 'Alexander von Humboldt',
  },
  {
    date: '2021-07-12',
    quoteText: 'Wenn du auf eine Wand stößt, tritt sie ein.',
    author: 'Patti Smith',
  },
  {
    date: '2021-07-13',
    quoteText: 'Ein tiefer Fall führt oft zu höherem Glück.',
    author: 'William Shakespeare',
  },
  {
    date: '2021-07-14',
    quoteText: 'Über sich selbst zu lachen, heißt sich selbst zu lieben.',
    author: 'Mickey Mouse',
  },
  {
    date: '2021-07-15',
    quoteText: 'Gestern hast du morgen gesagt.',
    author: 'Unbekannt',
  },
  {
    date: '2021-07-16',
    quoteText: 'Erfolg ist die Belohnung für schwere Arbeit.',
    author: 'Sophokles',
  },
  {
    date: '2021-07-17',
    quoteText: 'Einige erzeugen Freude, wohin immer sie gehen. Andere, wann immer sie gehen.',
    author: 'Oscar Wilde',
  },
  {
    date: '2021-07-18',
    quoteText: 'Eine runde Persönlichkeit aufzubauen, hat nicht mit Essen zu tun.',
    author: 'M.B. Hermann',
  },
  {
    date: '2021-07-19',
    quoteText: 'Problemzonen beginnen im Kopf.',
    author: 'Beat Jan',
  },
  {
    date: '2021-07-20',
    quoteText: 'Man kann viel, wenn man sich nur recht viel zutraut.',
    author: 'Alexander von Humboldt',
  },
  {
    date: '2021-07-21',
    quoteText: 'Lernen ist Erfahrung. Alles andere ist nur Information.',
    author: 'Albert Einstein',
  },
  {
    date: '2021-07-22',
    quoteText: 'Niemand tut etwas ohne Motivation.',
    author: 'Volker Harmgardt',
  },
  {
    date: '2021-07-23',
    quoteText: 'Nimm dir 3 Minuten um kurz inne zu halten und durchzuatmen.',
    author: 'Dein Alberta-Team',
  },
  {
    date: '2021-07-24',
    quoteText: 'Mit Frauen soll man sich nie unterstehen zu scherzen.',
    author: 'Johann Wolfgang von Goethe',
  },
  {
    date: '2021-07-25',
    quoteText: 'Der Vogel, der früh aufsteht, frisst den Wurm. Der Wurm, der früh aufsteht, wird vom Vogel gefressen.',
    author: 'Milena A.L',
  },
  {
    date: '2021-07-26',
    quoteText: 'Inspiration ist die Basis der Kunst - Reflexion die Entwicklung.',
    author: 'Chinesische Weisheit',
  },
  {
    date: '2021-07-27',
    quoteText: 'Gestern hast du morgen gesagt.',
    author: 'Unbekannt',
  },
  {
    date: '2021-07-28',
    quoteText: 'Heute ist internationaler Tag der Freundschaft!',
    author: 'Dein Alberta-Team',
  },
  {
    date: '2021-07-29',
    quoteText: 'Wer Freude bei der Arbeit hat, ist imstande, viel zu leisten.',
    author: 'Marion Hedda Ilse Gräfin Dönhoff',
  },
  {
    date: '2021-07-30',
    quoteText: 'Im Grunde sind es doch Verbindungen mit Menschen, die dem Leben seinen Wert geben.',
    author: 'Wilhelm von Humboldt',
  },
  {
    date: '2021-07-31',
    quoteText: 'Heute ist Harry Potters Geburtstag! Wir wünschen alles Gute!',
    author: 'Dein Alberta-Team',
  },
  {
    date: '2021-08-01',
    quoteText: 'Ändere deine Gedanken und du veränderst deine Welt.',
    author: 'Norman Vincent Peale',
  },
  {
    date: '2021-08-02',
    quoteText: 'Ein reicher Mensch ist einer, der weiß dass er genug hat.',
    author: 'Laotse',
  },
  {
    date: '2021-08-03',
    quoteText: 'Wem genug zu wenig ist, dem ist nichts genug.',
    author: 'Unbekannt',
  },
  {
    date: '2021-08-04',
    quoteText: 'Probleme kann man niemals mit derselben Denkweise lösen, durch die sie entstanden sind.',
    author: 'Albert Einstein',
  },
  {
    date: '2021-08-05',
    quoteText: 'Egal ob du rennst oder gehst. Der Weg bleibt der selbe.',
    author: 'Japanische Weisheit',
  },
  {
    date: '2021-08-06',
    quoteText: 'Heute ist internationaler Tag des Bieres! Prost!',
    author: 'Dein Alberta-Team',
  },
  {
    date: '2021-08-07',
    quoteText: 'Stop starting. Start finishing.',
    author: 'Agile',
  },
  {
    date: '2021-08-08',
    quoteText: 'Zwischen zu früh und zu spät liegt immer nur ein Augenblick',
    author: 'Franz Werfel',
  },
  {
    date: '2021-08-09',
    quoteText: 'Wo Anmaßung mir wohl gefällt? An Kindern. Denen gehört die Welt.',
    author: 'Johann Wolfgang von Goethe',
  },
  {
    date: '2021-08-10',
    quoteText: 'Die größte Offenbarung ist die Stille.',
    author: 'Laotse',
  },
  {
    date: '2021-08-11',
    quoteText: 'Es gibt Augenblicke, da gelingt uns alles. Kein Grund zu erschrecken: Das geht vorüber.',
    author: 'Jules Renard',
  },
  {
    date: '2021-08-12',
    quoteText: 'Glück ist das einzige, was wir anderen geben können, ohne es selbst zu haben.',
    author: 'Carmen Sylva',
  },
  {
    date: '2021-08-13',
    quoteText: 'Wir suchen die Wahrheit. Finden wollen wir sie aber nur dort, wo es uns beliebt.',
    author: 'Marie von Ebner-Eschenbach',
  },
  {
    date: '2021-08-14',
    quoteText: 'Immer wenn wir lachen, stirbt irgendwo ein Problem.',
    author: 'Unbekannt',
  },
  {
    date: '2021-08-15',
    quoteText: 'Wer viel Geld hat, ist reich. Wer keine Krankheit hat, ist glücklich!',
    author: 'Chinesische Weisheit',
  },
  {
    date: '2021-08-16',
    quoteText: 'Das Auge macht das Bild, nicht die Kamera.',
    author: 'Gisèle Freund',
  },
  {
    date: '2021-08-17',
    quoteText: 'Müde macht uns die Arbeit die wir liegen lassen, nicht die wir tun.',
    author: 'Marie von Ebner- Eschenbach',
  },
  {
    date: '2021-08-18',
    quoteText: 'Wo Freundlichkeit herrscht, gibt es Güte, und wo es Güte gibt, da ist auch Magie.',
    author: 'Aus Disneys Cinderella',
  },
  {
    date: '2021-08-19',
    quoteText: 'Heute ist Welt-Foto-Tag? Heute schon ein Selfie gemacht?',
    author: 'Dein Alberta-Team',
  },
  {
    date: '2021-08-20',
    quoteText: 'Wer einen Fehler gemacht hat und ihn nicht korrigiert, begeht einen Zweiten.',
    author: 'Konfuzius',
  },
  {
    date: '2021-08-21',
    quoteText: 'Misserfolg ist lediglich eine Gelegenheit, mit neuen Ansichten noch einmal anzufangen.',
    author: 'Henry Ford',
  },
  {
    date: '2021-08-22',
    quoteText: 'Oberflächlichkeit fördert die Spontanität. Tiefgründigkeit fördert die gesamte Entwicklung',
    author: 'Sylvia Amstadt',
  },
  {
    date: '2021-08-23',
    quoteText: 'Erfolg steigt nur zu Kopf, wenn dort der erforderliche Hohlraum vorhanden ist.',
    author: 'Unbekannt',
  },
  {
    date: '2021-08-24',
    quoteText: 'Lernen ist wie Rudern gegen den Strom. Hört man damit auf, treibt man zurück.',
    author: 'Laozi',
  },
  {
    date: '2021-08-25',
    quoteText:
      'Der Vorteil der Klugheit liegt darin, dass man sich dumm stellen kann. Das Gegenteil ist schon schwieriger.',
    author: 'Kurt Tucholksky',
  },
  {
    date: '2021-08-26',
    quoteText: 'Ich denke niemals an die Zukunft. Sie kommt früh genau.',
    author: 'Albert Einstein',
  },
  {
    date: '2021-08-27',
    quoteText: 'Es ist nicht zu wenig Zeit, die wir haben, sondern es ist zu viel Zeit, die wir nicht nutzen.',
    author: 'Lucius Annaeus Seneca',
  },
  {
    date: '2021-08-28',
    quoteText: 'Erfolg hat immer mit Teamwork zu tun.',
    author: 'Hannes Feiersinger',
  },
  {
    date: '2021-08-29',
    quoteText: 'Humor ist der Knopf, der verhindert, dass uns der Kragen platzt.',
    author: 'Hermann Hesse',
  },
  {
    date: '2021-08-30',
    quoteText: 'Eine gute Schwäche ist besser als eine schlechte Stärke.',
    author: 'Charles Aznavour',
  },
  {
    date: '2021-08-31',
    quoteText: 'Ohne meine Stimmungsschwankungen gäbe es ja gar keine Stimmung.',
    author: 'Sylvia Amstadt',
  },
  {
    date: '2021-09-01',
    quoteText: 'Heute ist Tag des Zebrastreifens! Fahr vorsichtig!',
    author: 'Dein Alberta-Team',
  },
  {
    date: '2021-09-02',
    quoteText: 'Man muß die Tatsachen kennen, bevor man sie verdrehen kann.',
    author: 'Mark Twain',
  },
  {
    date: '2021-09-03',
    quoteText: 'Das Gewissen ist eine Schwiegermutter, deren Besuch nie endet.',
    author: 'Henry Louis Mencken',
  },
  {
    date: '2021-09-04',
    quoteText: 'Heute ist Welttag des Bartes! Mach den Kollegen doch mal ein Kompliment :)',
    author: 'Dein Alberta-Team',
  },
  {
    date: '2021-09-05',
    quoteText: 'Keine Schuld ist dringender, als die, Danke zu sagen.',
    author: 'Marcus Tullius Cicero',
  },
  {
    date: '2021-09-06',
    quoteText: 'Leben ist das was passiert, während du beschäftigt bist, andere Pläne zu machen.',
    author: 'John Lennon',
  },
  {
    date: '2021-09-07',
    quoteText: 'Man sieht nur mit dem Herzen gut. Das Wesentliche ist für die Augen unsichtbar',
    author: 'Der kleine Prinz',
  },
  {
    date: '2021-09-08',
    quoteText: 'Schließe deine Augen und sieh.',
    author: 'James Joyce',
  },
  {
    date: '2021-09-09',
    quoteText: 'Heute ist Tag des Wiener Schnitzels! Guten Appetit!',
    author: 'Dein Alberta-Team',
  },
  {
    date: '2021-09-10',
    quoteText: 'Heute ist der Tausche-Ideen-aus-Tag. Du hast eine Idee zu Alberta? Lass es uns wissen!',
    author: 'Dein Alberta-Team',
  },
  {
    date: '2021-09-11',
    quoteText: 'Kein Geist ist in Ordnung, dem der Sinn für Humor fehlt.',
    author: 'Samuel Coleridge',
  },
  {
    date: '2021-09-12',
    quoteText: 'Die Musik wird treffend als Sprache der Engel beschrieben.',
    author: 'Thomas Carlyle',
  },
  {
    date: '2021-09-13',
    quoteText: 'Heute ist internationaler Tag der Schokolade - gönn dir mal was Süßes :)',
    author: 'Dein Alberta-Team',
  },
  {
    date: '2021-09-14',
    quoteText: 'Die Zeit ist schlecht? Du bist da, sie besser zu machen.',
    author: 'Unbekannt',
  },
  {
    date: '2021-09-15',
    quoteText: 'Es gibt Augenblicke, da gelingt uns alles. Kein Grund zu erschrecken: Das geht vorüber.',
    author: 'Jules Renard',
  },
  {
    date: '2021-09-16',
    quoteText: 'Man ist meistens nur durch Nachdenken unglücklich.',
    author: 'Joseph Joubert',
  },
  {
    date: '2021-09-17',
    quoteText: 'Ihr aber seht und sagt: Warum? Aber ich träume und sage: Warum nicht?',
    author: 'Georg Bernard Shaw',
  },
  {
    date: '2021-09-18',
    quoteText: 'Es gibt keinen Weg zum Frieden, denn Frieden ist der Weg.',
    author: 'Mahatma Gandhi',
  },
  {
    date: '2021-09-19',
    quoteText: 'Wir sind für nichts so dankbar wie für Dankbarkeit.',
    author: 'Marie von Ebner- Eschenbach',
  },
  {
    date: '2021-09-20',
    quoteText: 'Lass die Dinge los, die du nicht ändern kannst und konzentriere dich auf das, was du kannst.',
    author: 'Aus Disneys Ratatouille',
  },
  {
    date: '2021-09-21',
    quoteText: 'Der Humor ist der Regenschirm des Weisen.',
    author: 'Erich Kästner',
  },
  {
    date: '2021-09-22',
    quoteText: 'Es gibt tausend Krankheiten, aber nur eine Gesundheit.',
    author: 'Ludwig Börne',
  },
  {
    date: '2021-09-23',
    quoteText: 'Schön, dass du da bist!',
    author: 'Dein Alberta-Team',
  },
  {
    date: '2021-09-24',
    quoteText: "Der Mensch is guad, de Leit' san schlecht!",
    author: 'Karl Valentin',
  },
  {
    date: '2021-09-25',
    quoteText: 'Welche eine himmlische Empfindung ist es, seinem Herzen zu folgen.',
    author: 'Johann Wolfgang von Goethe',
  },
  {
    date: '2021-09-26',
    quoteText: 'Grüße doch heute einen Kollegen im Alberta-Chat!',
    author: 'Dein Alberta-Team',
  },
  {
    date: '2021-09-27',
    quoteText: 'Morgen werde ich das sein, was ich heute baue. Heute bin ich das, was ich gestern gebaut habe.',
    author: 'James Joyce',
  },
  {
    date: '2021-09-28',
    quoteText: 'Nur wer sein Alter verleugnet, fühlt sich wirklich alt.',
    author: 'Lilli Palmer',
  },
  {
    date: '2021-09-29',
    quoteText: 'Wir müssen der Wandel sein, den wir in der Welt zu sehen wünschen',
    author: 'Mahatma Gandhi',
  },
  {
    date: '2021-09-30',
    quoteText: 'Erkennst du deine eigene Stärke, erkennst du auch die Optionen, die sich dir bieten.',
    author: 'Monika Kühn-Görg',
  },
  {
    date: '2021-10-01',
    quoteText: 'Nicht ärgern, nur wundern.',
    author: 'Deutsches Sprichwort',
  },
  {
    date: '2021-10-02',
    quoteText: 'Tierschutz ist Erziehung zur Menschlichkeit.',
    author: 'Albert Schweitzer',
  },
  {
    date: '2021-10-03',
    quoteText: 'Hakuna Matata. Das heißt: Keine Sorgen.',
    author: 'aus Disneys König der Löwen',
  },
  {
    date: '2021-10-04',
    quoteText: 'Nur die Zeit hat ewig Zeit.',
    author: 'Georg-Wilhelm Exler',
  },
  {
    date: '2021-10-05',
    quoteText: 'Wer viele Sprachen spricht, kann in vielen Sprachen Unsinn reden.',
    author: 'Roda Alexander',
  },
  {
    date: '2021-10-06',
    quoteText: 'Der einzige Ort, an dem der Erfolg vor der Arbeit kommt, ist im Wörterbuch.',
    author: 'Vidal Sassoon',
  },
  {
    date: '2021-10-07',
    quoteText: 'Heute ist Tag des Morgenmuffels - wir schlafen heute mal aus.',
    author: 'Dein Alberta-Team',
  },
  {
    date: '2021-10-08',
    quoteText: 'Wer will, dass die Welt so bleibt wie sie ist, der will nicht, dass sie bleibt.',
    author: 'Erich Fried',
  },
  {
    date: '2021-10-09',
    quoteText: 'Warum sollte man der Marine beitreten, wenn man ein Pirat sein kann?',
    author: 'Steve Jobs',
  },
  {
    date: '2021-10-10',
    quoteText: 'Im Morgen ist alles anders als im Jetzt und im Gestern.',
    author: 'Nicole Engelhardt',
  },
  {
    date: '2021-10-11',
    quoteText: 'Im Kampf zwischen dir und der Welt, stelle dich immer auf die Seite der Welt.',
    author: 'Franz Kafka',
  },
  {
    date: '2021-10-12',
    quoteText: 'Heute ist internationaler Tag der Frustrationsschreie - AAH!',
    author: 'Dein Alberta-Team',
  },
  {
    date: '2021-10-13',
    quoteText: 'Was die Welt vorwärtstreibt, ist nicht die Liebe, sondern der Zweifel.',
    author: 'Ustinov Peter',
  },
  {
    date: '2021-10-14',
    quoteText: 'Für kein Tier auf der Welt wird soviel gearbeitet wie für die Katz.',
    author: 'Unbekannt',
  },
  {
    date: '2021-10-15',
    quoteText: 'Zeit hat, wer sich Zeit nimmt.',
    author: 'Georg-Wilhelm Exler',
  },
  {
    date: '2021-10-16',
    quoteText: 'Entweder musst du deine Wünsche modifizieren oder deine Fähigkeiten verstärken.',
    author: 'Emanuel James',
  },
  {
    date: '2021-10-17',
    quoteText:
      'Es ist nicht deine Schuld, dass die Welt ist, wie sie ist. Es wäre nur deine Schuld, wenn sie so bleibt.',
    author: 'Die Ärzte',
  },
  {
    date: '2021-10-18',
    quoteText: 'Ein hübsches Kompliment ist eine glaubwürdige Übertreibung.',
    author: 'Alexander Peter',
  },
  {
    date: '2021-10-19',
    quoteText: 'Der Narr hält sich für weise, aber der Weise weiß, dass er ein Narr ist.',
    author: 'William Shakespeare',
  },
  {
    date: '2021-10-20',
    quoteText: 'Sage nicht "Ich kann es nicht". Es muss heißen "Ich kann es noch nicht".',
    author: 'Unbekannt',
  },
  {
    date: '2021-10-21',
    quoteText: 'Das Komplexe ist einfach, das Einfache ist komplex.',
    author: 'Angus Young',
  },
  {
    date: '2021-10-22',
    quoteText: 'Die größten Menschen sind jene, die anderen Hoffnung geben können.',
    author: 'Ernst Ferstl',
  },
  {
    date: '2021-10-23',
    quoteText: 'Es sind Fehler, die einen wirklich wachsen lassen. Du musst schlecht werden, um gut zu werden.',
    author: 'Paula Scher',
  },
  {
    date: '2021-10-24',
    quoteText: 'Wie happy bist du mit Alberta? Lass es uns wissen! Schreib uns im Alberta-Chat.',
    author: 'Dein Alberta-Team',
  },
  {
    date: '2021-10-25',
    quoteText: 'Solange Menschen denken, dass Tiere nicht fühlen, müssen Tiere fühlen, dass Menschen nicht denken.',
    author: 'Unbekannt',
  },
  {
    date: '2021-10-26',
    quoteText: 'Den Duft von Sommerregen nennt man “Petrichor”, von “petros” (Stein) und “ichor” (Blut der Götter).',
    author: 'Die Zeit Wissen',
  },
  {
    date: '2021-10-27',
    quoteText: 'Jeder fällt mal hin, aber erst, wenn man wieder aufsteht, lernt man zu laufen.',
    author: 'aus Disneys Bambi',
  },
  {
    date: '2021-10-28',
    quoteText: 'Ein Mensch lernt wenig von seinem Siege, aber viel von der Niederlage.',
    author: 'Unbekannt',
  },
  {
    date: '2021-10-29',
    quoteText: 'Zu niemanden ist man ehrlicher als zum Suchfeld von Google.',
    author: 'Constanze Kurz',
  },
  {
    date: '2021-10-30',
    quoteText: 'Ein Fremdwort für “Fremdwort” ist auch “Xenismus".',
    author: 'Die Zeit Wissen',
  },
  {
    date: '2021-10-31',
    quoteText: 'Happy Halloween!',
    author: 'Dein Alberta-Team',
  },
  {
    date: '2021-11-01',
    quoteText: 'Warte nicht. Es gibt nie den passenden Moment.',
    author: 'Napoleon',
  },
  {
    date: '2021-11-02',
    quoteText: 'Der Blick in die Zukunft ist nur in der Gegenwart möglich.',
    author: 'Georg-Wilhelm Exler',
  },
  {
    date: '2021-11-03',
    quoteText: 'Liebe Männer, herzlichen Glückwunsch zum Weltmännertag!',
    author: 'Dein Alberta-Team',
  },
  {
    date: '2021-11-04',
    quoteText: 'Wer dir überlegen, den beneide nicht. Wer dir unterlegen den verachte nicht.',
    author: 'Japanische Weisheit',
  },
  {
    date: '2021-11-05',
    quoteText: 'Geduld hat was mit Zeit zu tun. Manchmal auch mit viel Zeit.',
    author: 'Klaus Seibold',
  },
  {
    date: '2021-11-06',
    quoteText: 'Dankbarkeit ist das blühen des Glücks.',
    author: 'Unbekannt',
  },
  {
    date: '2021-11-07',
    quoteText: 'Erfolg ist, der eigenen Klarheit zu folgen.',
    author: 'Christoph Reiter',
  },
  {
    date: '2021-11-08',
    quoteText: 'Es gibt tausend Krankheiten, aber nur eine Gesundheit.',
    author: 'Carl Ludwig Börne',
  },
  {
    date: '2021-11-09',
    quoteText: 'Gib jedem Tag die Chance, der schönste deines Lebens zu werden.',
    author: 'Mark Twain',
  },
  {
    date: '2021-11-10',
    quoteText: 'Heilung ist eine Frage der Zeit. Manchmal ist es aber auch eine Frage der günstigen Gelegenheit.',
    author: 'Hippokrates',
  },
  {
    date: '2021-11-11',
    quoteText: 'Nichts ist wertvoller, als ein Mensch der ehrlich zu dir ist.',
    author: 'Martin Pioch',
  },
  {
    date: '2021-11-12',
    quoteText: 'Wege entstehen dadurch, dass man sie geht.',
    author: 'Franz Kafka',
  },
  {
    date: '2021-11-13',
    quoteText: 'Glück ist kein Zufall.',
    author: 'Georg-Wilhelm Exler',
  },
  {
    date: '2021-11-14',
    quoteText: 'Der Schwache kann nicht verzeihen. Verzeihen ist eine Eigenschaft des Starken.',
    author: 'Mahatma Gandhi',
  },
  {
    date: '2021-11-15',
    quoteText: 'Man liebt, weil man liebt. Dafür gibt es keinen Grund.',
    author: 'Paulo Coehlo',
  },
  {
    date: '2021-11-16',
    quoteText: 'Es ist der Geist, der sich den Körper baut.',
    author: 'Friedrich Schiller',
  },
  {
    date: '2021-11-17',
    quoteText: 'Manchmal sollte man sich lieber Nudeln statt Sorgen machen.',
    author: 'Unbekannt',
  },
  {
    date: '2021-11-18',
    quoteText: 'Geradeaus kann man nicht sehr weit kommen.',
    author: 'Der kleine Prinz',
  },
  {
    date: '2021-11-19',
    quoteText: 'Freundlichkeit ist eine Sprache, die Taube hören und Blinde lesen können',
    author: 'Mark Twain',
  },
  {
    date: '2021-11-20',
    quoteText: 'Gesundheit ist nicht alles, aber ohne Gesundheit ist alles nichts.',
    author: 'Arthur Schopenhauer',
  },
  {
    date: '2021-11-21',
    quoteText:
      'Erfolg, Wohlstand, Gesundheit und bereichernde Beziehungen sind Folgen des Glücks und nicht die Ursache.',
    author: 'Deepak Chopra',
  },
  {
    date: '2021-11-22',
    quoteText: 'Zufrieden sein heißt glücklich sein.',
    author: 'Martin Pioch',
  },
  {
    date: '2021-11-23',
    quoteText: 'Vergebung ändert nie deine Vergangenheit, aber bereichert deine Zukunft.',
    author: 'Japanische Weisheit',
  },
  {
    date: '2021-11-24',
    quoteText: 'Es gibt nur eine Krankheit, wie es nur eine Gesundheit gibt.',
    author: 'Ernst Jünger',
  },
  {
    date: '2021-11-25',
    quoteText: 'Über sich selbst zu lachen, heißt sich selbst zu lieben.“',
    author: 'aus Disneys Mickey Mouse',
  },
  {
    date: '2021-11-26',
    quoteText: 'Wer beim Säen träge wird, wird beim Ernten neidisch.',
    author: 'Japanische Weisheit',
  },
  {
    date: '2021-11-27',
    quoteText: 'Wer sich sorgt, ist selten glücklich.',
    author: 'Grabher Markus',
  },
  {
    date: '2021-11-28',
    quoteText: 'Der, der das Schiff erfunden hat, hat auch den Schiffbruch erfunden.',
    author: 'Seth Godin',
  },
  {
    date: '2021-11-29',
    quoteText: 'Umgib dich mit Menschen, die sich nach Sonnenschein anfühlen.',
    author: 'Unbekannt',
  },
  {
    date: '2021-11-30',
    quoteText:
      'Ein jeder hat seine eigne Art, glücklich zu sein, und niemand darf verlangen, dass man es in der seinigen sein soll.',
    author: 'Heinrich von Kleist',
  },
  {
    date: '2021-12-01',
    quoteText: 'Gesundheit bekommt man nicht im Handel, sondern durch den Lebenswandel.',
    author: 'Sebastian Kneipp',
  },
  {
    date: '2021-12-02',
    quoteText: 'Die meisten Menschen leben in den Ruinen ihrer Gewohnheiten.',
    author: 'Jean Cocteau',
  },
  {
    date: '2021-12-03',
    quoteText: 'Der Sieger hat viele Freunde, der Besiegte hat gute Freunde.',
    author: 'Unbekannt',
  },
  {
    date: '2021-12-04',
    quoteText: 'Na? Schon die ersten Plätzchen gebacken?',
    author: 'Dein Alberta-Team',
  },
  {
    date: '2021-12-05',
    quoteText:
      'Leben allein genügt nicht, sagte der Schmetterling. Sonnenschein, Freiheit und eine kleine Blume muss man auch haben.',
    author: 'Hand Christian Andersen',
  },
  {
    date: '2021-12-06',
    quoteText: 'Es gibt wohl nur wenig Tiere, die uns für Menschen halten.',
    author: 'Alfred Edmund Brehm',
  },
  {
    date: '2021-12-07',
    quoteText: 'Wer nicht weiß, wohin er will, der darf sich nicht wundern, wenn er ganz woanders ankommt.',
    author: 'Mark Twain',
  },
  {
    date: '2021-12-08',
    quoteText: 'Das Geheimnis des Erfolgs ist: es zu suchen!',
    author: 'Unbekannt',
  },
  {
    date: '2021-12-09',
    quoteText: 'Wichtig ist nicht besser zu sein als alle anderen. Wichtig ist, besser zu sein als du gestern warst.',
    author: 'Japanische Weisheit',
  },
  {
    date: '2021-12-10',
    quoteText: 'Freundschaft, das ist eine Seele in zwei Körpern.',
    author: 'Josi',
  },
  {
    date: '2021-12-11',
    quoteText: 'Wer immer das tut was er schon kann, der bleibt immer das was er schon ist.',
    author: 'Katrin Fröstl',
  },
  {
    date: '2021-12-12',
    quoteText: 'Freiheit und Leben kann man uns nehmen, die Ehre nicht.',
    author: 'Otto Wels',
  },
  {
    date: '2021-12-13',
    quoteText: 'Der Wechsel allein ist das Beständige.',
    author: 'Arthur Schopenhauer',
  },
  {
    date: '2021-12-14',
    quoteText: 'Keiner ist so blind, wie der der nicht sehen will.',
    author: 'Japanische Weisheit',
  },
  {
    date: '2021-12-15',
    quoteText: 'Die wahre Freude ist die Freude am anderen.',
    author: 'Unbekannt',
  },
  {
    date: '2021-12-16',
    quoteText: 'Na? Schon den Weihnachtsbaum aufgestellt?',
    author: 'Dein Alberta-Team',
  },
  {
    date: '2021-12-17',
    quoteText: 'Mit einem Freund durch die Dunkelheit zu gehen ist besser als allein im Licht zu gehen.',
    author: 'Helen Keller',
  },
  {
    date: '2021-12-18',
    quoteText: 'Man entdeckt keine neuen Länder ohne das Ufer für eine lange Zeit aus den Augen zu verlieren.',
    author: 'André Gide',
  },
  {
    date: '2021-12-19',
    quoteText: 'Verlasse heute deine Komfortzone. Reflektiere am abend deinen Tag. Was ist passiert?',
    author: 'Achtsamkeit',
  },
  {
    date: '2021-12-20',
    quoteText: 'Phantasie ist wichtiger als Wissen, denn Wissen ist begrenzt.',
    author: 'Martin Limbeck',
  },
  {
    date: '2021-12-21',
    quoteText: 'Sie dürfen niemals Angst vor dem haben, was Sie tun, wenn es richtig ist.',
    author: 'Albert Einstein',
  },
  {
    date: '2021-12-22',
    quoteText: 'Weihnachten steht vor der Tür :-) Stimme dich heute schon mal mit Plätzchen und einer Tasse Tee ein.',
    author: 'Dein Alberta-Team',
  },
  {
    date: '2021-12-23',
    quoteText: 'Die Liebe ist ein Erleben des anderen in der eigenen Seele.',
    author: 'Rudolf Steiner',
  },
  {
    date: '2021-12-24',
    quoteText: 'Das Alberta-Team wünscht ein frohes und besinnliches Weihnachtsfest!',
    author: 'Dein Alberta-Team',
  },
  {
    date: '2021-12-25',
    quoteText: 'Liebe Grüße zum ersten Weihnachtstag!',
    author: 'Dein Alberta-Team',
  },
  {
    date: '2021-12-26',
    quoteText: 'Einen schönen zweiten Feiertag!',
    author: 'Dein Alberta-Team',
  },
  {
    date: '2021-12-27',
    quoteText: 'Es gibt eine unbezahlbare "Währung" gegen die "Einsamkeit". Freunde.',
    author: 'Klaus Seibold',
  },
  {
    date: '2021-12-28',
    quoteText: 'Wenn du es träumen kannst, kannst du es auch tun.',
    author: 'Walt Disney',
  },
  {
    date: '2021-12-29',
    quoteText: 'Eine Veränderung bewirkt steht eine weitere Veränderung.',
    author: 'Niccole Machiavelli',
  },
  {
    date: '2021-12-30',
    quoteText: 'Ob Silvester oder nicht, du bist der Knaller, auch im neuen Jahr! Einen guten Rutsch ins neue Jahr!',
    author: 'Dein Alberta-Team',
  },
]; // tslint:enable
